<template>
    <div
        class="locations"
        ref="locations"
    >
        <!-- <div class="container">
            <h3 class="h3 mb-4 light-text text-center text-uppercase">
                Lokalita
            </h3>

            <div
                v-if="!loading"
                class="locations-distance d-flex justify-content-md-center m-n2"
                data-aos="fade-in"
            >
                <template v-for="distance in distances">
                    <locations-check
                        v-model="form.distance"
                        :value="distance"
                        class="p-2"
                        @change="filter"
                    >
                        {{ distance.text }}
                    </locations-check>
                </template>
            </div>
        </div> -->


        <template v-if="!loading">
            <div
                class="locations-map"
                ref="map"
            />
            <div class="container">
                <!--<div
                    v-if="categories.length"
                    class="locations-categories d-flex"
                    data-aos="fade-up"
                    data-aos-delay="600"
                >
                    <template v-for="category in categories">
                        <locations-check
                            v-model="form.categories"
                            :value="category.title"
                            class=""
                            @change="filter"
                        >
                            <img
                                :src="category.icon"
                                alt=""
                            />
                            {{ category.title }}
                        </locations-check>
                    </template>
                </div>-->
                <!-- LOCATION LIST -->
                <div class="locations-list" :class="{ collapsed: collapsed }" ref="locationsList">
                    <div class="group">
                        <h3 class="h3">Atrakcie v okolí</h3>
                        <button class="btn mb-5" @click="toggleList">
                            <span class="mr-2">
                                <img src="/img/icons/chevron-right.svg" class="btn-icon" alt="chevron right">
                            </span>
                            {{ collapsed ? "Zatvoriť" : "Otvoriť" }}  
                        </button>
                    </div>
                    <!-- <h3 class="h3 mb-3">Atrakcie v okolí</h3> -->
                    <ul class="locations-list-inner" >
                        <li 
                        v-for="(marker, index) in filteredMarkers" :key="index"
                        @click="openMarkerModal(marker)"
                        >
                            <img :src="marker.category_icon" alt="Category Icon" :width="38" :height="45" />
                            <span class="location-list-description">
                                <div class="location-list-title">{{ marker.title }}</div>
                                <div class="location-list-distance">{{ marker.distance }} {{ marker.time ? '('+marker.time+')' : '' }}</div>
                            </span>
                            <img src="/img/icons/chevron-right-grey.svg" alt="chevron right icon">
                        </li>
                    </ul>
                </div>
                <!-- MODAL -->
                <transition name="fade">
                    <div v-if="selectedMarker" class="col-10 col-md-7 marker-modal">
                        <div class="marker-modal-inner">
                            <span @click="closeMarkerModal" class="close-button">
                                <img src="/img/icons/close-modal.svg" alt="close modal">
                            </span> 
                            <h2 class="h3 mb-2">{{ selectedMarker.title }}</h2>
                            <p class="mb-3" v-if="selectedMarker.description">{{ selectedMarker.description }}</p>
                            <div class="row justify-content-between">
                                <div class="col-12 col-lg-6 marker-modal-left">
                                    <div class="location-list-distance-open">
                                        <span v-if="selectedMarker.distance"><img src="/img/icons/modal-distance.svg" class="mr-2" alt="distance icon">{{ selectedMarker.distance }}</span>
                                        <span v-if="selectedMarker.time"><img src="/img/icons/modal-car.svg" class="mr-2" alt="car icon">{{ selectedMarker.time}}</span>
                                    </div>
                                    <p v-if="selectedMarker.content">{{ selectedMarker.content }}</p>
                                </div>
                                <div class="col-lg-6 marker-modal-right">
                                   <img v-if="selectedMarker.image" :src="selectedMarker.image" class="img-fluid" alt="Location image" style="border-radius: 9px; width: 100%">
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </template>
        <div
            v-else
            class="py-5 text-center"
        >
            <img src="/img/icons/loader.svg" alt="loader"/>
        </div>
    </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import stylesMap from './stylesMap.json';
import LocationsCheck from './components/LocationsCheck.vue';

export default {
    components: {LocationsCheck},
    data() {
        return {
            collapsed: true,
            selectedMarker: null,
            showModal:false,
            loading: true,
            scrolled: false,
            currentInfoWindow: null,
            apiKey: 'AIzaSyCA1mR1ZGwhs-1JEbOVh8emSxpSe7EuM0Y',
            mapOptions: {
                center: {
                    lat: 49.147125098720046,
                    lng: 20.287335116564307
                },
                zoom: 13,
                disableDefaultUI: true,
                styles: stylesMap,
            },
            // Markers
            mainMarker: {
                position: '49.147125098720046, 20.287335116564307',
                title: 'Apartmány Forton',
                content: 'Apartmány Forton',
                category_icon_pin: '/img/icons/forton_marker.svg',
                category_title: 'main',
            },
            markers: [],
            googleMarkers: [],
            mainMarkerSize: {
                width: 75,
                height: 86,
            },
            markerSize: {
                width: 45,
                height: 45,
            },
            // Filter
            distances: [
                {text: 'do 5 minút pešo', duration: 10, travelMode: 'WALKING', zoom: 15},
                {text: 'do 15 minút pešo', duration: 20, travelMode: 'WALKING', zoom: 14},
                {text: 'do 10 minút autom', duration: 15, travelMode: 'DRIVING', zoom: 13},
            ],
            categories: [],
            form: {
                distance: [],
                categories: [],
            },
        };
    },
    async mounted() {
        await this.getMarkers();

        this.loadMap();

        // window.addEventListener('scroll', this.scrollToShowMarkers);

        if (window.innerWidth <= 767) {
            this.collapsed = false;
        }
    },
    computed: {
        filteredMarkers() {
            return this.markers.filter(marker => {
                return this.form.categories.includes(marker.category_title);
            });
        },
    },
    methods: {
        loadMap() {
            const loader = new Loader({
                apiKey: this.apiKey,
                version: 'weekly',
            });

            loader.load().then(() => {
                this.initMap();
                this.initDistanceService();

                // Markers
                this.addMarkers(this.markers, true);
            });
        },

        initMap() {
            this.map = new google.maps.Map(this.$refs.map, this.mapOptions);
        },

        initDistanceService() {
            this.distanceService = new google.maps.DistanceMatrixService();
        },

        async getMarkers() {
            try {
                const response = await axios.get(`/api/map/pins/list`);

                this.markers = response.data.data;

                this.categories = this.markers
                    .filter((item, index, array) => index === array.findIndex(i => i.category_title === item.category_title))
                    .map(item => {
                        return {
                            icon: item.category_icon,
                            title: item.category_title,
                        };
                    });

                this.form.categories = this.categories.map(item => item.title);

                this.loading = false;
            } catch (error) {
                console.error(error);
            }
        },

        scrollToShowMarkers() {
            if (!this.scrolled) {
                const section = this.$refs.locations;
                const rect = section.getBoundingClientRect();

                // getting the visible window area
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                // checking if the section is visible
                if (rect.top <= 300 /*&& rect.bottom <= windowHeight*/) {
                    this.scrolled = true;
                    this.addMarkers(this.markers, true);
                }
            }
        },

        addMarkers(markers, firstLoad = false) {
            if (firstLoad) {
                markers.push(this.mainMarker);
            }

            markers.forEach(markerData => {
                const [lat, lng] = markerData.position.split(',');

                const icon = {
                    url: markerData.category_icon_pin,
                    scaledSize: markerData.category_title !== 'main' ? new google.maps.Size(this.markerSize.width, this.markerSize.height) : new google.maps.Size(this.mainMarkerSize.width, this.mainMarkerSize.height),
                };

                const marker = new google.maps.Marker({
                    map: this.map,
                    position: new google.maps.LatLng(
                        parseFloat(lat),
                        parseFloat(lng),
                    ),
                    icon: icon,
                    title: markerData.title,
                    animation: firstLoad ? google.maps.Animation.DROP : 4,
                });

              const contentString = `
                  <h2 class="h3 mb-6">
                    ${markerData.title}
                  </h2>
                  ${(markerData.distance && markerData.time) ? `<div class="location-list-distance-open">
                        <span>
                            <img src="/img/icons/modal-distance.svg" class="mr-2" alt="distance icon">
                            ${markerData.distance}
                        </span>
                        <span>
                            <img src="/img/icons/modal-car.svg" class="mr-2" alt="car icon">
                            ${markerData.time}
                        </span>
                  </div>` : ''}`;

                    const infoWindow = new google.maps.InfoWindow({
                        content: contentString,
                        ariaLabel: markerData.title,
                    });

                    // Add event for open
                    marker.addListener('click', () => {
                        // Close any currently open InfoWindow
                        if (this.currentInfoWindow) {
                            this.currentInfoWindow.close();
                        }
                        // Open the new InfoWindow and track it
                        infoWindow.open(this.map, marker);
                        this.currentInfoWindow = infoWindow;
                    });

                // Save to googleMarkers
                if (markerData.category_title !== 'main') {
                    this.googleMarkers.push(marker);
                }
            });
        },

        // Filter
        async filter() {
            if (this.map) {
                // Reset to single value for checkbox
                if (this.form.distance.length > 1) {
                    this.form.distance.shift();
                }

                // Reset showed markers
                this.googleMarkers.forEach(marker => {
                    marker.setVisible(false);
                });

                this.googleMarkers = [];

                // Filtered markers
                let filteredMarkers = this.markers.filter(item => this.form.categories.includes(item.category_title));

                // Caclulated markers
                if (this.form.distance.length > 0) {
                    filteredMarkers = await this.calculateDistance(filteredMarkers);
                    // Change zoom
                    this.map.setZoom(this.form.distance[0].zoom);
                } else {
                    // Change zoom
                    this.map.setZoom(this.mapOptions.zoom);
                }

                // Add markers to map
                this.addMarkers(filteredMarkers);
            }
        },

        calculateDistance(markers) {
            const matrixOptions = {
                    origins: [this.mainMarker.position],
                    destinations: markers.map(item => item.position),
                    travelMode: this.form.distance[0].travelMode,
                },
                calculatedMarkers = [];

            return new Promise((resolve) => {
                this.distanceService.getDistanceMatrix(matrixOptions, (response, status) => {
                    if (status === 'OK') {
                        response.rows[0].elements.forEach((item, index) => {
                            if (item.duration.value <= (this.form.distance[0].duration * 60)) {
                                calculatedMarkers.push(markers[index]);
                            }
                        });

                        resolve(calculatedMarkers);
                    }
                });
            });
        },
        openMarkerModal(marker) {
            this.selectedMarker = marker;
            this.showModal = true;
        },

        closeMarkerModal() {
            this.selectedMarker = null;
            this.showModal = false;
        },
        toggleList() {
            this.collapsed = !this.collapsed;
            
            // Scroll to the top of the list container when closing it
            if (!this.collapsed) {
                this.$nextTick(() => {
                    const listContainer = this.$refs.locationsList;
                    listContainer.scrollTop = 0;
                });
            }
        },
    },
};
</script>